import * as React from "react";
const SvgDiamond = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121 90" {...props}><path fill="none" fillRule="evenodd" stroke="#979797" d="M30.367.715h58.616l31.14 28.366L59.82 88.715.122 29.08z" vectorEffect="non-scaling-stroke" /></svg>;
export default SvgDiamond;